import React from "react";
import { RecoilRoot } from "recoil";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./routes/Home";
import "./index.css";
import Error from "./routes/Error";
import UserDetails from "./routes/UserDetails";
import Responsive from "./routes/Responsive";
import Getprofile from "./routes/Getprofile";
import Marketplacece from "./routes/Marketplace";
import ManageServers from "./routes/ManageServers";
import Top from "./routes/Top";
import CustomizeRank from "./routes/CustomizeRank";
import Apex from "./routes/Apex";
import BattlePass from "./routes/BattlePass";
import Layout from "./components/Layout";

const router = createBrowserRouter([
  {
    // Human-facing pages share the dark Layout shell (navbar, footer,
    // grain, page transitions)
    element: <Layout />,
    errorElement: <Error />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/profile", element: <UserDetails /> },
      { path: "/Marketplace", element: <Marketplacece /> },
      { path: "/ManageServers", element: <ManageServers /> },
      { path: "/battlepass", element: <BattlePass /> },
      { path: "/:platform/:name/apex", element: <Apex /> },
      { path: "/responsive", element: <Responsive /> },
    ],
  },
  // Puppeteer render targets — fixed-viewport pages recorded by the bot.
  // They must stay outside the Layout (no navbar/footer/transitions).
  {
    path: "/getprofile/:userid",
    element: <Getprofile />,
  },
  {
    path: "/:userid/rankcard",
    element: <CustomizeRank />,
  },
  {
    path: "/top",
    element: <Top />,
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <RecoilRoot>
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  </RecoilRoot>
);
